import { AbstractControl, ValidationErrors } from '@angular/forms';

export class PhoneValidators {
  // US default number
  static get US_PhoneNumber() {
    return (control: AbstractControl): ValidationErrors | null => {
      const regex = new RegExp(
        '^(\\+\\d{1,2}\\s?)?1?-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$'
      );

      return regex.test(control.value) ? null : { phone: true };
    };
  }
}
